<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Edição" :required="true" v-model="form.edicao" />

					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="data"> Publicação</label>
						<div class="col-sm-3">
							<flat-pickr class="col-xs-10 col-sm-3 form-control" v-model="form.publicacao" :config="config"
								placeholder="Data" name="date"></flat-pickr>
						</div>
					</div>
					<input-form-text textInput="Conteúdo" :required="true" v-model="form.conteudo" />
					<div class="form-group">
						<label class="col-sm-3 control-label">Ano</label>
						<div class="col-sm-3">
							<select v-model="form.ano" class="form-control" required>
								<option value="">Selecione</option>
								<option v-for="op in opcoesAno" :key="op.value" :value="op.value">{{ op.label }}</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<file-upload v-if="!allFiles.length" ref="fupload" :url="'/v1/doem/upload'" :id="null"
								:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf"
								:isFile="true"></file-upload>
							<items-edit v-else :files="allFiles" url="/v1/doem/upload" id="id" :isFile="true"></items-edit>
						</div>
					</div>

				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
		flatPickr,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		const anoAtual = new Date().getFullYear() - 2013
		return {
			title: 'DOEN',
			form: {
				edicao: '',
				publicacao: '',
				conteudo: '',
				arquivo: '',
				ano: anoAtual,
			},
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
			opcoesAno: [],
			config: {
				wrap: true,
				altInput: true,
				// eslint-disable-next-line no-useless-escape
				altFormat: 'd \\de F \\de Y',
				dateFormat: 'Y-m-d',
				locale: Portuguese
			},
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		gerarOpcoesAno() {
			const anoAtual = new Date().getFullYear()
			const anoMinimo = 2014
			const opcoes = []

			for (let ano = anoAtual; ano >= anoMinimo; ano--) {
				opcoes.push({
					value: ano - 2013, // 2014 → 1, 2023 → 10, etc.
					label: ano.toString()
				})
			}
			return opcoes
		},
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = {
				...this.form,
			}

			if (this.$route.params.id) {
				const resp = await req(`/v1/doem/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				if (!this.allFiles.length) {
					this.isActive = false
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/servicos/doem')
			} else {
				const resp = await req('/v1/doem', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/servicos/doem')
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/doem/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.edicao = resp.edicao
			this.form.publicacao = resp.publicacao
			this.form.conteudo = resp.conteudo
			this.form.arquivo = resp.arquivo
			this.form.ano = resp.ano
			this.allFiles = resp.arquivo ? [{ id: this.$route.params.id, files: resp.arquivo }] : ''
			this.isActive = false
		},
		formatarDataParaInput(data) {
			// de 'YYYY-MM-DD' para 'DD/MM/YYYY'
			if (!data) return ''
			const [ano, mes, dia] = data.split('-')
			return `${dia}/${mes}/${ano}`
		},

		formatarDataParaSalvar(data) {
			// de 'DD/MM/YYYY' para 'YYYY-MM-DD'
			if (!data) return ''
			const [dia, mes, ano] = data.split('/')
			return `${ano}-${mes}-${dia}`
		},

		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		this.opcoesAno = this.gerarOpcoesAno()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
